/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Rolecreated1Inputs */

const en_settings_collaborators_rolecreated1 = /** @type {(inputs: Settings_Collaborators_Rolecreated1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created`)
};

/**
* | output |
* | --- |
* | "Created" |
*
* @param {Settings_Collaborators_Rolecreated1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_rolecreated1 = /** @type {((inputs?: Settings_Collaborators_Rolecreated1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Rolecreated1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_rolecreated1(inputs)
});
export { settings_collaborators_rolecreated1 as "settings_collaborators_roleCreated" }